<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12 columns is-marginless is-vcentered" v-if="!isConsultation">
        <div class="column is-11  is-paddingless">
          <b-field :label="$t(label)">
            <b-autocomplete icon="magnify" v-model="searchSchemaComptable"
                            :placeholder="
                            $t('catalogue.newProduct.comptabilite.schemaComptable.search')"
                            field="libelleAutocomplete"
                            dropdown-position="bottom"
                            :data="autoCompleteData"
                            :loading="isFetching"
                            :open-on-focus="true"
                            @input="getSchemaComptable"
                            @select="item => selectSchemaComptable(item)">
              <template slot="header">
                <a @click="checkPermissions(permsSchemaComptable.maj)
                ? addNewSchema = true : showPopUp()">
                  <a class="lien"
                     :class="{ 'text-access-no-permission' :
                     !checkPermissions(permsSchemaComptable.maj)}">
                    <span>{{$t('schemaComptableComponent.creationSchemaComptable')}}</span>
                  </a>
                </a>
              </template>
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('schemaComptableComponent.autocomplete.noResult')}}
                </div>
                <div v-else>{{$t('schemaComptableComponent.autocomplete.search')}}</div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-1 mgl-10px mgt-30px  is-paddingless"
          v-if="objetAvecSchemaComptable[propertyForObject]"
          @click="deleteSchemaComptable()">
          <b-icon icon="delete-forever" type="is-danger" class="is-cursor-pointer">
          </b-icon>
        </div>
      </div>
      <div v-if="!objetAvecSchemaComptable[propertyForObject] && isConsultation"
           class="column is-12">
        <b-field :label="$t('schemaComptableComponent.informations.title')"
                 custom-class="has-text-default is-italic has-text-weight-light">
        </b-field>
      </div>
    </div>
    <div class="columns is-multiline" v-if="objetAvecSchemaComptable[propertyForObject]">
      <b-field :label="$t('schemaComptableComponent.informations.title')"
               v-if="isConsultation"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].libelle }}
                    </span>
      </b-field>
      <b-field :label="$t('schemaComptableComponent.informations.compteNormal')"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
               <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteNormal }}
                    </span>
               </b-tooltip>
      </b-field>
      <b-field :label="$t('schemaComptableComponent.informations.compteExport')"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
               <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteExport }}
                    </span>
               </b-tooltip>
      </b-field>
      <b-field
        :label="$t('schemaComptableComponent.informations.compteTvaDebit')"
        class="column is-4-fullhd is-6-tablet mgb-0"
        custom-class="has-text-default is-italic has-text-weight-light">
            <b-tooltip class="width-100percent"
              :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip')">
                <span class="has-text-weight-bold">
                {{ objetAvecSchemaComptable[propertyForObject].compteTva }}
                </span>
            </b-tooltip>
      </b-field>
      <b-field
        :label="$t('detailSchemaComptable.informationSchemaComptable.tvaSurEncaissement')"
              class="column is-4-fullhd is-6-tablet mgb-0"
              custom-class="has-text-default is-italic has-text-weight-light">
          <span class="has-text-weight-bold">
            {{ $t(`general.${objetAvecSchemaComptable[propertyForObject].tvaSurEncaissement ?
            'oui' : 'non'}`) }}
          </span>
      </b-field>
      <b-field :label="
                $t('schemaComptableComponent.informations.compteTvaEncaissement')"
              class="column is-4-fullhd is-6-tablet mgb-0"
              custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteTvaEncaissement }}
                    </span>
      </b-field>
      <b-field :label="
                $t('schemaComptableComponent.informations.produitConstate')"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteConstateDavance }}
                    </span>
      </b-field>
      <b-field v-if="priseEnCompteRemiseCompta" :label="
                $t('schemaComptableComponent.informations.compteRemiseHorsRegie')"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteRemiseGeneral }}
                    </span>
      </b-field>
      <b-field v-if="priseEnCompteRemiseCompta" :label="
                $t('schemaComptableComponent.informations.compteRemiseRegie')"
               class="column is-4-fullhd is-6-tablet mgb-0"
               custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ objetAvecSchemaComptable[propertyForObject].compteRemiseRegie }}
                    </span>
      </b-field>
    </div>
    <b-modal v-model="addNewSchema" has-modal-card class="modal">
      <add-new-schema-comptable @newSchemaComptable="selectSchemaComptable">
      </add-new-schema-comptable>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/schemaComptable/index';
import messageErreur from '@/services/general/messageErreur';
import { SCHEMA_COMPTABLE } from '@/configuration/general/permissionsParametrageConf';
import addNewSchemaComptable from '@/components/catalogue/produitGeneral/p_addNewSchemaComptable';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'schemaComptable',
  props: {
    objetAvecSchemaComptable: {
      type: Object,
      required: true,
    },
    isConsultation: {
      type: Boolean,
      required: false,
      default: false,
    },
    propertyForId: {
      type: String,
      required: false,
      default: 'schemaComptableId',
    },
    propertyForObject: {
      type: String,
      required: false,
      default: 'schemaComptable',
    },
    label: {
      type: String,
      required: false,
      default: 'schemaComptableComponent.title',
    },
  },
  components: {
    addNewSchemaComptable,
  },
  data() {
    return {
      searchSchemaComptable: null,
      autoCompleteData: [],
      isFetching: false,
      permsSchemaComptable: SCHEMA_COMPTABLE,
      addNewSchema: false,
    };
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    modificationAutoComplete(schemaComptable) {
      this.autoCompleteData = [];
      schemaComptable.items.forEach((schema) => {
        schema.libelleAutocomplete = schema.libelle + (schema.compteNormal ? ' - ' + schema.compteNormal : '');
        this.autoCompleteData.push(schema);
      });
    },
    selectSchemaComptable(schemaComptableSelected) {
      if (!schemaComptableSelected) return;
      this.searchSchemaComptable = schemaComptableSelected.libelle;
      this.objetAvecSchemaComptable[this.propertyForId] = schemaComptableSelected.id;
      this.objetAvecSchemaComptable[this.propertyForObject] = schemaComptableSelected;
    },
    deleteSchemaComptable() {
      this.searchSchemaComptable = '';
      this.objetAvecSchemaComptable[this.propertyForId] = null;
      this.objetAvecSchemaComptable[this.propertyForObject] = null;
    },
    async getAllSchemaComptable() {
      const parameter = {
        query: {
          auto: this.searchSchemaComptable,
        },
      };
      await this.modificationAutoComplete((await getAll(parameter)).data.result);
    },
    getSchemaComptable: debounce(async function loadData() {
      this.isFetching = true;
      try {
        if (this.searchSchemaComptable.length === 0) {
          this.isFetching = false;
          return;
        }
        const parameter = {
          query: {
            auto: this.searchSchemaComptable,
          },
        };
        await this.modificationAutoComplete((await getAll(parameter)).data.result);
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw (e);
      }
    }, 500),
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    priseEnCompteRemiseCompta() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key]);
      if (this.objetAvecSchemaComptable[this.propertyForObject]) {
        this.searchSchemaComptable = this.objetAvecSchemaComptable[this.propertyForObject].libelle;
      }
      await this.getAllSchemaComptable();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
